import { classNames, useState } from 'libs/react';
import { React } from 'libs/react';
import { FormInputPicker } from 'components/form/FormInputPicker';
import { ContactListQuery } from 'graphql/Contact/queries/ContactListQuery';
import { ClientListQuery } from 'graphql/Client/queries/ClientListQuery';
import { Pane } from 'components/Pane';
import { Panel } from 'components/Panel';
import { FormSection } from 'components/form/FormSection';
import { useDealItemPicker } from './DealItemPicker';
import { ClientQuickAddMenu } from 'modules/client/menus/ClientQuickAddMenu';
import { ContactQuickAddMenu } from 'modules/contact/menus/ContactQuickAddMenu';
import { ContactQuickEditMenu } from 'modules/contact/menus/ContactQuickEditMenu';
import { ClientQuickEditMenu } from 'modules/client/menus/ClientQuickEditMenu';
import './DealItemPickerContactPane.scss';
import { Phone } from 'components/Phone';
import { ContactListExternalQuery } from 'graphql/Contact/queries/ContactListExternalQuery';
import { ClientListExternalQuery } from 'graphql/Client/queries/ClientListExternalQuery';
import { Button } from 'components/Button';
/**
 * @component DealItemPickerContactPane
 * @since 1.0.0
 */
export function DealItemPickerContactPane(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    const { style } = Object.assign({ style: 'normal' }, props);
    const { client, contact, onClientChange, onContactChange } = useDealItemPicker();
    const [clientQuickAddOpen, setClientQuickAddOpen] = useState(false);
    const [contactQuickAddOpen, setContactQuickAddOpen] = useState(false);
    const [contactEditOpen, setContactEditOpen] = useState(false);
    const [clientEditOpen, setClientEditOpen] = useState(false);
    /**
     * @function onSelectContact
     * @since 1.0.0
     * @hidden
     */
    const onSelectContact = (selection) => {
        onContactChange(selection);
    };
    /**
     * @function onSelectClient
     * @since 1.0.0
     * @hidden
     */
    const onSelectClient = (selection) => {
        onClientChange(selection);
    };
    /**
     * @function onContactEditOpen
     * @since 1.0.0
     * @hidden
     */
    const onContactEditOpen = () => {
        setContactEditOpen(true);
    };
    /**
     * @function onContactEditClose
     * @since 1.0.0
     * @hidden
     */
    const onContactEditClose = () => {
        setContactEditOpen(false);
    };
    /**
     * @function onContactUpdateDone
     * @since 1.0.0
     * @hidden
     */
    const onContactUpdateDone = (updatedContact) => {
        onContactChange(updatedContact);
    };
    /**
     * @function onClientEditOpen
     * @since 1.0.0
     * @hidden
     */
    const onClientEditOpen = () => {
        setClientEditOpen(true);
    };
    /**
     * @function onClientEditClose
     * @since 1.0.0
     * @hidden
     */
    const onClientEditClose = () => {
        setClientEditOpen(false);
    };
    /**
     * @function onClientUpdateDone
     * @since 1.0.0
     * @hidden
     */
    const onClientUpdateDone = (updatedClient) => {
        onClientChange(updatedClient);
    };
    const className = classNames('deal-item-picker-contact-pane', 'deal-item-picker-contact-pane--' + style, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "deal-item-picker-contact-pane__section" },
            React.createElement(FormSection, { title: t('Contact (optional)') },
                React.createElement(FormInputPicker, { placeholder: `${t('Select or create a contact')}`, createLabel: t('Create a contact'), noResultsLabel: t('No contact found.'), query: ContactListQuery, entity: "contact", externalQuery: ContactListExternalQuery, objectType: "contacts", externalObjectType: "contactsExternal", onSelect: (value) => {
                        onSelectContact(value);
                    }, format: (value) => {
                        var _a;
                        return ({
                            id: value.id,
                            title: (_a = value.fullname) !== null && _a !== void 0 ? _a : value.name,
                            infos: '',
                            asset: value.asset
                        });
                    }, creatable: true, onCreate: () => {
                        setContactQuickAddOpen(true);
                    }, singlePick: true })),
            contact && (React.createElement(Pane, null,
                React.createElement(Panel, { title: React.createElement("div", { className: "deal-item-picker-contact-pane__panel-header" },
                        React.createElement("span", null, contact.fullname),
                        React.createElement("div", { className: "deal-item-picker-contact-pane__panel-actions" },
                            React.createElement(Button, { picto: "pen-to-square", style: "picto", size: "small", onPress: onContactEditOpen }),
                            React.createElement(Button, { picto: "times", style: "picto", size: "small", onPress: () => {
                                    onContactChange(undefined);
                                } }))) },
                    React.createElement("div", { className: "deal-item-picker-contact-pane__contact" },
                        React.createElement("div", { className: "deal-item-picker-contact-pane__client__address" }, contact.location
                            ? ((_a = contact.location) === null || _a === void 0 ? void 0 : _a.address) +
                                ', ' +
                                ((_b = contact.location) === null || _b === void 0 ? void 0 : _b.city) +
                                ', ' +
                                ((_c = contact.location) === null || _c === void 0 ? void 0 : _c.postalcode)
                            : ''),
                        React.createElement("div", { className: "deal-item-picker-contact-pane__contact__email" }, (_d = contact.primaryEmail) === null || _d === void 0 ? void 0 : _d.email),
                        React.createElement("div", { className: "deal-item-picker-contact-pane__contact__phone" },
                            React.createElement(Phone, { value: (_f = (_e = contact.primaryPhone) === null || _e === void 0 ? void 0 : _e.phone) !== null && _f !== void 0 ? _f : '' }))))))),
        React.createElement("div", { className: "deal-item-picker-contact-pane__section" },
            React.createElement(FormSection, { title: t('Company (optional)') },
                React.createElement(FormInputPicker, { placeholder: `${t('Select or create a company')}`, createLabel: t('Create a company'), noResultsLabel: t('No company found.'), entity: "client", query: ClientListQuery, externalQuery: ClientListExternalQuery, objectType: "clients", externalObjectType: "clientsExternal", onSelect: (value) => {
                        onSelectClient(value);
                    }, format: (value) => ({
                        id: value.id,
                        title: value.name,
                        infos: '',
                        asset: value.asset
                    }), creatable: true, onCreate: () => {
                        setClientQuickAddOpen(true);
                    }, singlePick: true })),
            client && (React.createElement(Pane, null,
                React.createElement(Panel, { title: React.createElement("div", { className: "deal-item-picker-contact-pane__panel-header" },
                        React.createElement("span", null, client.name),
                        React.createElement("div", { className: "deal-item-picker-contact-pane__panel-actions" },
                            React.createElement(Button, { picto: "pen-to-square", style: "picto", size: "small", onPress: onClientEditOpen }),
                            React.createElement(Button, { picto: "times", style: "picto", size: "small", onPress: () => {
                                    onClientChange(undefined);
                                } }))) },
                    React.createElement("div", { className: "deal-item-picker-contact-pane__client" },
                        React.createElement("div", { className: "deal-item-picker-contact-pane__client__address" }, client.primaryLocation
                            ? ((_g = client.primaryLocation) === null || _g === void 0 ? void 0 : _g.address) +
                                ', ' +
                                ((_h = client.primaryLocation) === null || _h === void 0 ? void 0 : _h.city) +
                                ', ' +
                                ((_j = client.primaryLocation) === null || _j === void 0 ? void 0 : _j.postalcode)
                            : ''),
                        React.createElement("div", { className: "deal-item-picker-contact-pane__client__email" }, (_l = (_k = client.primaryLocation) === null || _k === void 0 ? void 0 : _k.primaryEmail) === null || _l === void 0 ? void 0 : _l.email),
                        React.createElement("div", { className: "deal-item-picker-contact-pane__client__phone" },
                            React.createElement(Phone, { value: (_p = (_o = (_m = client.primaryLocation) === null || _m === void 0 ? void 0 : _m.primaryPhone) === null || _o === void 0 ? void 0 : _o.phone) !== null && _p !== void 0 ? _p : '' }))))))),
        clientQuickAddOpen && (React.createElement(ClientQuickAddMenu, { open: clientQuickAddOpen, hideButton: true, redirect: false, onClientCreateDone: onSelectClient })),
        contactQuickAddOpen && (React.createElement(ContactQuickAddMenu, { open: contactQuickAddOpen, hideButton: true, redirect: false, onContactCreateDone: onSelectContact, isEndClient: true })),
        contactEditOpen && contact && (React.createElement(ContactQuickEditMenu, { open: contactEditOpen, contact: contact, onClose: onContactEditClose, onContactUpdateDone: onContactUpdateDone, isEndClient: true })),
        clientEditOpen && client && (React.createElement(ClientQuickEditMenu, { open: clientEditOpen, client: client, onClose: onClientEditClose, onClientUpdateDone: onClientUpdateDone }))));
}
